import { render } from "./BaseSection.vue?vue&type=template&id=7c99ef3c&scoped=true"
import script from "./BaseSection.vue?vue&type=script&lang=js"
export * from "./BaseSection.vue?vue&type=script&lang=js"

import "./BaseSection.vue?vue&type=style&index=0&id=7c99ef3c&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c99ef3c"]])

export default __exports__